import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolean',
  pure: false
})
export class BooleanPipe implements PipeTransform {

  transform(value: boolean, trueText: string, falseText: string): string {
    if (value === true && trueText !== undefined) {
        return trueText;
    } else if (value === false && falseText !== undefined) {
        return falseText;
    }
    return value === undefined || value === null ? '' : value.toString();
  }
}
